import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, KiloClassWeek } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseClassWeekProps {
  start: string;
  end: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useClassWeek({
  start,
  end,
  coaches,
  locations,
  eventTypes,
}: IUseClassWeekProps): UseQueryResult<{ data: Array<KiloClassWeek> }> {
  const params: UrlParams = { start, end };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(
    ['classes', 'week', start, end, coaches, eventTypes, locations],
    () => client.get(`kilo-classes/week/?${encodeUrlParams(params)}`),
    {
      enabled: !!start && !!end && (start < end || start === end),
    },
  );
}

export default useClassWeek;
